import React from 'react';
import styled from 'styled-components';
import Backdrop from '@mui/material/Backdrop';
import PropTypes from 'prop-types';
import spinner from '../../images/spinner.png';

const propTypes = {
  open: PropTypes.bool.isRequired,
};

const PageInner = styled.div`
  display: flex;
  align-items: center;
  width: 92px;
  height: 92px;
  position: relative;
  justify-content: center;
  background-color: #fff;
  border-radius: 8px;
  font-size: 14px;
`;
const Logo = styled.div`
  width: 52px;
  height: 52px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    display: block;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    position: absolute;
    animation: spin 1s linear infinite;
    -webkit-animation: spin 1s linear infinite;
  }
`;

const LoadingOverlay = ({ open }) => (
  <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
    <PageInner>
      <Logo>
        <img src={spinner} alt="logo" draggable="false" />
      </Logo>
    </PageInner>
  </Backdrop>
);

LoadingOverlay.propTypes = propTypes;

export default LoadingOverlay;
